<!--<div class="row auth-row">
  <div class="col-sm-1">
    <div class="row">
      <b>BETA</b>
    </div>
  </div>
  <div class="col-sm-6"></div>
  <div class="col-sm-5">
    <div class="row">
      <div class="col-sm-3">
        <a class="auth-row-a" routerLink="/CustService/ContactUs">Feedback</a>
      </div>
      <div class="col-sm-3">
        <a class="auth-row-a" routerLink="/CustService/ContactUs">Contact Us</a>
      </div>
      <div class="col-sm-3" *ngIf="!isLoggedIn">
        <a routerLink="/Login" class="auth-row-a" href="#"><i class="fas fa-lock fa-auth-icon"></i> Login</a>
      </div>
      <div class="col-sm-3" *ngIf="isLoggedIn">
        <a routerLink="/Logout" class="auth-row-a" href="#"><i class="fas fa-unlock fa-auth-icon"></i> Logout</a>
      </div>
      <div class="col-sm-3" *ngIf="!isLoggedIn">
        <a routerLink="/Register" class="auth-row-a" href="#">Register</a>
      </div>
      <div class="col-sm-3 welcome-name" style="padding: 0 !important;" *ngIf="isLoggedIn">
        <a routerLink="/MyProfile/Overview" class="auth-row-a " title="Welcome, {{firstName}}">Welcome, {{firstName}}</a>
      </div>
    </div>
  </div>
</div>-->
<div *ngIf="isLoggedIn" class="row alertMsg">
  <div *ngIf="showMsg && orgId == 1834" class="col-sm-12 notificationMsg"><i class="fas fa-info-circle"></i> There will be a pipe being worked on in your region on 1/12/2021 between 6AM-10AM<span *ngIf="showX" title="Hide Notifcation" class="float-right notificationMsgX" (click)="hideMsgX()"> x </span></div><span *ngIf="showPlus" title="Show Notifcation" class="float-right notificationMsgPlus" (click)="showMsgX()"> + </span>
</div>
<nav class="navbar navbar-default auth-row pull-right">
  <div class="container-fluid">
    <!-- Hamburger -->
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#example-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div *ngIf="!isLoggedIn">
        <a routerLink="Billing/Usage"><img class="current-bill-image logo-image navbar-brand" src="assets/Fenix.png" /></a>
      </div>
      <div *ngIf="isLoggedIn && (orgId != 1834)">
        <a routerLink="Billing/Usage"><img class="current-bill-image logo-image navbar-brand" src="assets/Fenix.png" /></a>
      </div>
      <div *ngIf="isLoggedIn && (orgId == 1834)">
        <a routerLink="Billing/Usage"><img class="current-bill-image logo-image navbar-brand" src="assets/OUC-logo.jpg" /></a>
      </div>
    </div>

    <!-- Collapsible Navbar -->
    <div class="collapse navbar-collapse" id="example-1">
      <ul class="nav navbar-nav navbar-right">
        <li *ngIf="isLoggedIn">
          <a routerLink="Billing/Usage" class="auth-row-a">
            Usage
          </a>
        </li>
        <li *ngIf="isLoggedIn">
          <a routerLink="ServiceStatus/Overview" class="auth-row-a">
            Service Status
          </a>
        </li>
        <li *ngIf="isLoggedIn">
          <a routerLink="CustService/Support" class="auth-row-a">
            Support Center
          </a>
        </li>
        <li *ngIf="isLoggedIn">
          <a routerLink="MyProfile/Overview" class="auth-row-a">
            My Profile
          </a>
        </li>
        <!--<li><a class="auth-row-a" routerLink="/CustService/ContactUs">Feedback</a></li>
        <li><a class="auth-row-a" routerLink="/CustService/ContactUs">Contact Us</a></li>-->
        <li *ngIf="!isLoggedIn">
          <a routerLink="/Login" class="auth-row-a" href="#"><i class="fas fa-lock fa-auth-icon"></i> Login</a>
        </li>
        <li *ngIf="isLoggedIn">
          <a routerLink="/Logout" class="auth-row-a" href="#"><i class="fas fa-unlock fa-auth-icon"></i> Logout</a>
        </li>
        <li *ngIf="!isLoggedIn">
          <a routerLink="/Register" class="auth-row-a" href="#">Register</a>
        </li>
      </ul>
    </div>

  </div>
</nav>



// WEBPACK FOOTER //
// ./src/app/auth-nav/auth-nav.component.html